export const formatDuration = (value) => {
  if (value === null || value === undefined) return '—';
  if (value < 1000) return `${Math.round(value)}ms`;
  if (value < 10000) return `${(value / 1000).toFixed(1)}s`;
  return `${Math.round(value / 1000)}s`;
};

export const formatCount = (value) =>
  value === null || value === undefined ? '—' : Math.round(value).toLocaleString();

export const formatRate = (value) =>
  value === null || value === undefined ? '—' : `${(value * 100).toFixed(1)}%`;

export const formatWait = (minutes) => {
  if (minutes === null || minutes === undefined) return '—';
  if (minutes >= 60) return `${(minutes / 60).toFixed(1)}h`;
  return `${Math.round(minutes)}m`;
};

export const formatDelta = (value) => {
  if (value === null || value === undefined) return '—';
  if (Math.abs(value) < 0.05) return '→ 0.0%';
  return `${value > 0 ? '↑' : '↓'} ${Math.abs(value).toFixed(1)}%`;
};

export const deltaClass = (value) => {
  if (value === null || value === undefined || Math.abs(value) < 0.05) {
    return 'text-gray-600';
  }
  return value > 0 ? 'text-red-dark' : 'text-green-dark';
};

export const compareRows = (key, direction, accessors = {}) => {
  const read = accessors[key] || ((row) => row[key]);
  const dir = direction === 'desc' ? -1 : 1;
  const missing = (value) => value === null || value === undefined || value === '';
  return (a, b) => {
    const av = read(a);
    const bv = read(b);
    if (missing(av) && missing(bv)) return 0;
    if (missing(av)) return 1;
    if (missing(bv)) return -1;
    if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * dir;
    return String(av).localeCompare(String(bv), undefined, { numeric: true }) * dir;
  };
};
